import { SHOP_MAP } from 'constant/shop';

const TIMEZONE_MAP = {
  TOKYO: 'Asia/Tokyo',
  SHANG_HAI: 'Asia/Shanghai',
};

const getStoreTimezone = (storeId: number | string) => {
  const storeIdNum = +storeId;

  if (storeIdNum === SHOP_MAP.HONGKONG || storeIdNum === SHOP_MAP.SINGAPORE) {
    return TIMEZONE_MAP.SHANG_HAI;
  } else {
    return TIMEZONE_MAP.TOKYO;
  }
};

export default getStoreTimezone;
